import { lazy, Suspense } from 'react'
import { AppSuspenseFallback } from '@/components/AppSuspenseFallback'

const SeoSummaryPage = lazy(() => import('../pages/SeoSummaryPage'))

export function PerformanceHomeSwitch() {
  return (
    <Suspense fallback={<AppSuspenseFallback />}>
      <SeoSummaryPage />
    </Suspense>
  )
}
